module.exports = __webpack_public_path__ + "media/entities/2011-a6bf7021.png";